import { formatCents } from "../../../../../utils/money";

/** large — широк модал; compact — таблет с двете колони (модал 560), за да
 *  се съберат две суми една до друга; phone — телефон на цяла ширина. */
export type AmountFigureSize = "large" | "compact" | "phone";

const FIGURE_SIZES: Record<AmountFigureSize, { label: string; amount: string; currency: string }> = {
  large: { label: "text-[14px]", amount: "text-[40px] leading-[44px]", currency: "gap-2 text-[15px]" },
  compact: { label: "text-[13px]", amount: "text-[26px] leading-[30px]", currency: "gap-1.5 text-[13px]" },
  phone: { label: "text-[14px]", amount: "text-[32px] leading-[36px]", currency: "gap-2 text-[15px]" },
};

/** Вертикалната черта между двете суми горе в лявата колона на „Закрий". */
export const AmountFigureDivider = ({ size }: { size: AmountFigureSize }) => (
  <span aria-hidden className={`w-px shrink-0 bg-pos-line2 ${size === "large" ? "mx-6" : "mx-4"}`} />
);

/** „Общо за плащане:" / „Бакшиш:" / „Ресто:" и сумата под него с „EUR". */
export function AmountFigure({
  label,
  cents,
  size,
  className,
  muted = false,
}: {
  label: string;
  cents: number;
  size: AmountFigureSize;
  /** Цветът на сумата. */
  className: string;
  /** Отстъпил назад надпис (платено в брой — на преден план е рестото). */
  muted?: boolean;
}) {
  const sizes = FIGURE_SIZES[size];
  return (
    <div className="flex min-w-0 flex-col gap-2">
      <span
        className={`whitespace-nowrap font-bold leading-[17px] ${muted ? "text-pos-muted" : "text-pos-ink"} ${sizes.label}`}
      >
        {label}
      </span>
      <div className={`flex items-baseline font-bold ${sizes.currency}`}>
        <span
          className={`font-pos-mono tracking-[-.02em] [font-variant-numeric:tabular-nums] ${sizes.amount} ${className}`}
        >
          {formatCents(cents)}
        </span>
        <span className="text-pos-muted">EUR</span>
      </div>
    </div>
  );
}
